import { Box, Container, Grid, Typography, Link, IconButton } from "@mui/material";
import { Facebook, Instagram, LinkedIn } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box
      sx={{
        background: 'linear-gradient(45deg, #2c3e50, #3498db)', // Gradient background
        color: '#ffffff',
        padding: '60px 20px',
        marginTop: '50px',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          {/* 📌 Company Info */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ fontFamily: '"Montserrat", sans-serif' }}>
              About Us
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, fontFamily: '"Montserrat", sans-serif' }}>
              We provide premium digital resources, tools, and subscriptions at the best prices.
            </Typography>
          </Grid>

          {/* 📌 Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ fontFamily: '"Montserrat", sans-serif' }}>
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              <Link
                href="/"
                color="inherit"
                underline="none"
                sx={{ 
                  fontFamily: '"Montserrat", sans-serif',
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    color: '#ff9800', 
                    transform: 'translateX(5px)',
                  },
                }}
              >
                Home
              </Link>
              <Link
                href="/courses"
                color="inherit"
                underline="none"
                sx={{ 
                  fontFamily: '"Montserrat", sans-serif',
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    color: '#ff9800', 
                    transform: 'translateX(5px)',
                  },
                }}
              >
                Courses
              </Link>
              <Link
                href="/tools"
                color="inherit"
                underline="none"
                sx={{ 
                  fontFamily: '"Montserrat", sans-serif',
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    color: '#ff9800', 
                    transform: 'translateX(5px)',
                  },
                }}
              >
                Premium Tools
              </Link>
              <Link
                href="/reviews"
                color="inherit"
                underline="none"
                sx={{ 
                  fontFamily: '"Montserrat", sans-serif',
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    color: '#ff9800', 
                    transform: 'translateX(5px)',
                  },
                }}
              >
                User Reviews
              </Link>
              <Link
                href="/buy-premium"
                color="inherit"
                underline="none"
                sx={{ 
                  fontFamily: '"Montserrat", sans-serif',
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    color: '#ff9800', 
                    transform: 'translateX(5px)',
                  },
                }}
              >
                Buy Premium
              </Link>
            </Box>
          </Grid>

          {/* 📌 Social Media Links */}
          <Grid item xs={12} sm={6} md={4} textAlign="center">
            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ fontFamily: '"Montserrat", sans-serif' }}>
              Follow Us
            </Typography>
            <Box>
              <IconButton 
                href="https://www.facebook.com/talha.talhasiddique.5?_rdc=1&_rdr#" 
                target="_blank" 
                sx={{ 
                  color: '#ffffff', 
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    color: '#1877F2', 
                    transform: 'scale(1.2)',
                  },
                }}
              >
                <Facebook />
              </IconButton>
              <IconButton 
                href="https://www.instagram.com/talha__siddique/" 
                target="_blank" 
                sx={{ 
                  color: '#ffffff', 
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    color: '#E1306C', 
                    transform: 'scale(1.2)',
                  },
                }}
              >
                <Instagram />
              </IconButton>
              <IconButton 
                href="https://www.linkedin.com/in/talha-siddique-28961b279/" 
                target="_blank" 
                sx={{ 
                  color: '#ffffff', 
                  transition: 'all 0.3s ease',
                  '&:hover': { 
                    color: '#0077B5', 
                    transform: 'scale(1.2)',
                  },
                }}
              >
                <LinkedIn />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* 📌 Copyright Section */}
        <Box textAlign="center" mt={4} sx={{ opacity: 0.7 }}>
          <Typography variant="body2" sx={{ fontFamily: '"Montserrat", sans-serif' }}>
            © {new Date().getFullYear()} TS. All Rights Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;